import React, { Component } from 'react'
import PropTypes from 'prop-types'
import withLangSearch from 'containers/withLangSearch'
import { StaggeredMotion, spring } from 'react-motion'
import styled from 'styled-components'
import { Container, Row, Col } from 'styled-bootstrap-grid'
import { media } from 'styled-bootstrap-grid'
import theme from 'ui/styles/theme'
import easing from 'ui/styles/easing'
import getRelativeUrl from 'utils/getRelativeUrl'
import DocumentExtended from './documentExtended'
import { CSSTransition } from 'react-transition-group';
import './search.css'
import LocalizedString from '../../generic/LocalizedString'
import withTranslations from 'containers/withTranslations'
import { compose } from 'react-apollo'
import { withRouter } from 'react-router'
import withLangDoc from '../../../../containers/withLangDoc'




const Wrapper = styled.div`
  padding: 5rem 0 0 0;
`

const Alternating = styled.div`

`

const Text = styled.p`
  font-size: 14px;
  width: 100%;
  margin-bottom: 0.25em;
  font-size: 20px;
  align-self: center;


  ${media.sm`
    margin: 0;
  `}
`

const Label = styled.div`
font-size: 14px;
width: 100%;
margin-bottom: 0.25em;
font-size: 20px;
align-self: center;


${media.sm`
  margin: 0;
`}
`

const TextDiv = styled.div`
font-size: 14px;
width: 100%;
margin-bottom: 0.25em;
font-size: 20px;
align-self: center;
height: 100%;


${media.sm`
  margin: 0;
`}
`

const Desc = styled(Text)`
font-size: 16px;
word-break: break-word;
`
const Title = styled(Text)`
  width: 100%;
  font-size: 20px;
  align-self: flex-start;
  margin-bottom: 0;
  
  ${media.lg`
  margin-bottom: 0.8em;
  `}

  ${media.sm`
    font-weight: 500;

  `}
`

const Result = styled.a`
  display: flex;
  flex-wrap: wrap;
  text-decoration: none;
  color: #004077;
  padding: 20px;
  width: 100%;
  max-height: 450px;
  min-height:300px
  transition: background-color 0.3s ${easing.easeOutCubic}, color 0.3s ${easing.easeOutCubic};
  
  margin-top: 10px;
  align-content: ${props => props.align};
  height: 300px;
  justify-content: center;
  border: 1px solid #E8E8E8;
  background-color: ${(props) => (props.docType === 'products' ? theme.colors.tones.lightest : "white")};


  ${Title}{
    align-self: flex-start;
    text-align: left;
  }

  ${media.lg`
  height: 450px;
  `}

  
  ${media.sm`
  `}
  &:hover {
    background-color: #d1d1d1 !important;
    color: #004077;
  }


  ${Desc}{
    text-align: left;
  }



  ${Text}:hover & {
    color: #004077;
  }
`
const More = styled.p`
text-decoration: underline;
text-align: left;
font-weight: 500;
width: 100%;
margin-top: 0.7em;
`

const ResultDoc = styled.div`
  display: flex;
  flex-wrap: wrap;
  text-decoration: none;
  color: #004077;
  padding: 20px;
  width: 100%;
  max-height: 450px;
  min-height:300px
  transition: background-color 0.3s ${easing.easeOutCubic}, color 0.3s ${easing.easeOutCubic};
  background-color: white;
  margin-top: 10px;
  align-content: center;
  cursor: pointer;
  border: 1px solid #E8E8E8;


  ${media.lg`
  height: 450px;
  `}
  ${media.sm`
  `}
  &:hover {
    background-color: #d1d1d1 !important;

  }


`

const ProductImage = styled.div`
background: url(${props => props.url}) center / cover;
width: 70%;
height: 80%;
padding: 0px;

${media.lg`
width: 80%;
`}

`

const Header = styled(Row)`
  font-weight: 500;
  display: none;
  padding: 20px 0;
  text-transform: uppercase;
  margin-top: 20px;

  ${media.lg`
    display: flex;
  `}
`

const HeaderCol = styled(Col)`
  .label {
    border-top: 1px solid ${theme.colors.tones.dark};
    width: 100%;
    padding: 20px 0 40px;
  }
`


const ProductTitle = styled(Text)`
text-align: center;
`

const MenuButton = styled.a`
text-transform: uppercase;
width: 31%;
border-radius: 99em;
height: 50px;
line-height: 50px;
border: none;
background-color: #004077;
color: white;
text-decoration: none;
text-align: center;

${media.lg`
width: 28%;
`}


:hover{
  background-color: rgb(155, 180, 200);
  color: white;
}
`
const ButtonContainer = styled.div`
display: flex;
width: 100%;
justify-content: space-between;
font-size: 0.7em;

${media.lg`
font-size: 1em;
`}
`

const Address = styled.div`
display: flex;
flex-wrap: wrap;

> *{
  width: 100%;
  margin-top: 10px;
  color: #004077;
}

> a {
  text-decoration: none;
}
`
const AddressTitle = styled.h3`
margin-top: 100px;
`

const Toggler = styled.div`
width: 100%;
height: 70px;
background-color: #F5F5F5;
line-height: 70px;
padding-left: 20px;
margin-top: 10px;
display:flex;
justify-content: space-between;
align-items: center;
`
const Flag = styled.div`
display: inline-flex;
font-size: 25px;
`
const Icon = styled.div`
  width: 25px;
  height: 25px;
  border-radius: 25px;
  border: 1px solid #878585;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 10px;

  svg {
    transition: transform 0.3s ${easing.easeOutCubic};
    transform: rotate(${(props) => (props.open ? 135 : 0)}deg);
  }
`
const FooterFixed = styled.div`
width: 100%;
margin-top: 100px;
bottom: 0;
position: unset;
margin-top: 400px;
${media.xl`
position: ${(props) => (props.res ? "unset" : "absolute")};
margin-top: ${(props) => (props.res ? "100px" : "400px")};

`}
`

//----------Backlog----------
//Search back button doesn't work (sometimes)

class Results extends Component {
  constructor(props) {
    super(props);
    this.state = {
      results: [],
      pages: [],
      products: [],
      documents: [],
      searchResults: [],
      anim: false,
      isMobile: false,
      prod: true,
      doc: true,
      page: true,
      loaded: false,
      changed: false
    }


  }
  static propTypes = {
    search: PropTypes.string.isRequired
  }



  prepareResults() {
    if(this.props.searchResults !== undefined && this.props.documentResults !== undefined) {
      let results = []
      const searchResults = {...this.props.searchResults, ...this.props.documentResults}
      this.setState({ searchResults: searchResults })
      for (let group in searchResults) {
        searchResults[group].nodes.map(node =>
          results.push(node)
        )
      }
      results.sort((a, b) => {
        return new Date(b.date) - new Date(a.date)
      })
      //Here we are creating new arrays that store objects from search. New set makes sure that duplicates are not going to appear in the array
      //It connects two arrays documents and documentsTags.
      if (searchResults !== undefined) {
        const documentsArr = [...new Set([...searchResults.documents.nodes, ...searchResults.documentsTags.nodes])];
        const pagesArr = [...new Set([...searchResults.pages.nodes, ...searchResults.pagesTags.nodes])];
        const productsArr = [...new Set([...searchResults.products.nodes, ...searchResults.productsTags.nodes])];
        this.setState({ documents: documentsArr, pages: pagesArr, products: productsArr })
      }
      this.setState({ results, anim: results.length === 0 })
    }

  }
  //Not in use
  splitResults(resultsArray) {
    for (let i = 0; i < resultsArray.length; i++) {
      if (resultsArray[i].__typename === 'Product') {
        this.setState({ products: [...this.state.products, resultsArray[i]] }) //simple value
      }
    }
  }


  componentDidMount() {
    this.detectMobile()
    window.addEventListener('resize', this.detectMobile)
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.detectMobile)
  }

  detectMobile = () => {
    const width = window.innerWidth
    const isMobile = width <= theme.grid.breakpoints.lg

    if (isMobile !== this.state.isMobile) {
      this.setState({ isMobile })
    }
    if (isMobile && !this.state.changed) {
      this.setState({ prod: false, doc: false, page: false, changed: true })
    } else if (!isMobile && !this.state.changed) {
      this.setState({ prod: true, doc: true, page: true, changed: true })
    }

  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps !== this.props) {
      this.prepareResults()
    }
    if (/* this.state.results !== [] && */ !this.state.loaded) {
      this.onResultsLoad(this.state.results)
    }
    this.onTrigger(this.state.results.length, this.props.searchResultsLoading)

  }
  //Open PDF on div click becasue <a> is not allowed at that spot
  downloadDocument = (url) => {
    window.location.href = url;
  }

  getDefaultStyles() {
    const results = this.state.results

    let styles = []

    results.map(index => {
      return styles.push({ o: 0, t: 50 })
    })

    return styles
  }


  getSearchStyles(x) {
    let searchResults = this.state.searchResults;
    let documents = this.state.documents;
    let pages = this.state.pages;
    let products = this.state.products;
    let styles = [];

    //Styles split in order to make each category work with staggered motion
    if (x === 'documents') {
      documents.map(index => {
        if (index.status === "publish") {
          return styles.push({ o: 0, t: 50 })
        }
      })
      return styles
    } else if (x === 'products') {
      products.map(index => {
        if (index.status === "publish") {
          return styles.push({ o: 0, t: 50 })
        }
      })
      return styles
    } else if (x === 'pages') {
      pages.map(index => {
        if (index.status === "publish") {
          return styles.push({ o: 0, t: 50 })
        }

      })
      return styles
    }

  }


  onTrigger = (results, loading) => {
    this.props.parentCallback(results, loading);
  }

  //Send results back to a parent component. Called during props change
  onResultsLoad = (results) => {
    this.props.pullResults(results)
  }

  toPlainText = (html) => {
    let text = html.replace(/<[^>]+>/g, '');
    return text
  }

  //This method finds an index of a module specified in a typenamesToFind array. 
  //It is used to display text snippet from a page
  indexFinder = (array) => {
    const typenamesToFind = ['Modules__bodyText', 'Modules__imageAndText'];
    const indices = typenamesToFind.map(typename => {
      return array.modules.findIndex(module => module.__typename === typename)
    });
    //Return first value from the array
    //It is being checked for undefined in the call
    if (indices[0] !== -1) {
      return indices[0];
    } else {
      return indices[1];
    }
  }

  //Toggle results on click while on mobile
  toggleResult = (category) => {
    if (category === "products") {
      this.setState({ prod: !this.state.prod })
    } else if (category === "pages") {
      this.setState({ page: !this.state.page })
    }
    else {
      this.setState({ doc: !this.state.doc })
    }

  }

  render() {
    const {
      search,
      searchResultsLoading,
      visible
    } = this.props

    const {
      results,
      searchResults,
      anim,
      isMobile,
      prod,
      doc,
      page,
      documents,
      pages,
      products
    } = this.state

    return (
      <Wrapper key={results.length}>
        {visible &&
          <Container fluid>
            {results.length !== 0 &&
              <Header>
                <HeaderCol xlOffset={2} xl={3} lg={4}>
                  <Label className={"label"}><LocalizedString group='resultsLabels' string='products_label' /></Label>
                </HeaderCol>
                <HeaderCol xl={3} lg={4}>
                  <Label className={"label"}><LocalizedString group='resultsLabels' string='technical_info_label' /></Label>
                </HeaderCol>
                <HeaderCol xl={3} lg={4}>
                  <Label className={"label"}><LocalizedString group='resultsLabels' string='pages_label' /></Label>
                </HeaderCol>
              </Header>
            }
            {results.length !== 0 &&
              <Row>
                <Col xlOffset={2} xl={3} lg={4}>
                  {isMobile && !searchResultsLoading &&
                    <Toggler
                      onClick={() => this.toggleResult("products")}
                    >
                      <Flag><LocalizedString group='resultsLabels' string='products_label' /> {"(" + products.length + ")"}</Flag>
                      <Icon open={prod}>
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="13"
                          height="13"
                          viewBox="0 0 13 13"
                        >
                          <g
                            fill="none"
                            fillRule="evenodd"
                            stroke="#141414"
                            strokeLinecap="square"
                          >
                            <path d="M12 6.5H1" />
                            <path d="M6.5 1v11" />
                          </g>
                        </svg>
                      </Icon>
                    </Toggler>
                  }
                  {!searchResultsLoading && results.length && search && prod ?
                    <StaggeredMotion
                      defaultStyles={this.getSearchStyles('products')}
                      styles={prevInterpolatedStyles => prevInterpolatedStyles.map((_, i) => {
                        return i === 0
                          ? { o: spring(1), t: spring(0) }
                          : { o: spring(prevInterpolatedStyles[i - 1].o), t: spring(prevInterpolatedStyles[i - 1].t) }
                      })}
                    >
                      {interpolatingStyles =>
                        <Alternating>
                          {interpolatingStyles.map((style, i) =>

                            <Result
                              href={getRelativeUrl(products[i].link)}
                              key={i}
                              style={{ opacity: style.o, transform: `translateY(${style.t}px)` }}
                              align={'normal'}
                              docType={'products'}
                            >
                              <ProductImage url={products[i].image.sourceUrl} />
                              <ProductTitle>{products[i].title}</ProductTitle>
                            </Result>
                          )}
                        </Alternating>
                      }
                    </StaggeredMotion>
                    : searchResultsLoading ? <h1></h1> : <h1></h1>}
                </Col>
                <Col xl={3} lg={4}>
                  {isMobile && !searchResultsLoading &&
                    <Toggler
                      onClick={() => this.toggleResult("documents")}
                    >
                      <Flag><LocalizedString group='resultsLabels' string='technical_info_label' /> {"(" + searchResults.documents.nodes.length + ")"}</Flag>
                      <Icon open={doc}>
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="13"
                          height="13"
                          viewBox="0 0 13 13"
                        >
                          <g
                            fill="none"
                            fillRule="evenodd"
                            stroke="#141414"
                            strokeLinecap="square"
                          >
                            <path d="M12 6.5H1" />
                            <path d="M6.5 1v11" />
                          </g>
                        </svg>
                      </Icon>
                    </Toggler>
                  }
                  {!searchResultsLoading && results.length && search && doc && documents.length !== 0 ?
                    <StaggeredMotion
                      defaultStyles={this.getSearchStyles('documents')}
                      styles={prevInterpolatedStyles => prevInterpolatedStyles.map((_, i) => {
                        return i === 0
                          ? { o: spring(1), t: spring(0) }
                          : { o: spring(prevInterpolatedStyles[i - 1].o), t: spring(prevInterpolatedStyles[i - 1].t) }
                      })}
                    >
                      {interpolatingStyles =>
                        <Alternating>
                          {interpolatingStyles.map((style, i) =>
                            <ResultDoc
                              key={i}
                              style={{ opacity: style.o, transform: `translateY(${style.t}px)` }}

                            >
                              {/* <Text>{searchResults.documents.nodes[i].title}</Text> */}
                              <TextDiv>
                                <DocumentExtended
                                  id={documents[i].id}
                                  title={documents[i].title}
                                  url={documents[i].file.sourceUrl}
                                  pageNumber={1}
                                />
                              </TextDiv>
                            </ResultDoc>
                          )}
                        </Alternating>
                      }
                    </StaggeredMotion>
                    : searchResultsLoading ? <h1></h1> : <h1></h1>}
                </Col>
                <Col xl={3} lg={4}>
                  {isMobile && !searchResultsLoading &&
                    <Toggler
                      onClick={() => this.toggleResult("pages")}
                    >
                      <Flag><LocalizedString group='resultsLabels' string='pages_label' /> {"(" + pages.length + ")"}</Flag>
                      <Icon open={page}>
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="13"
                          height="13"
                          viewBox="0 0 13 13"
                        >
                          <g
                            fill="none"
                            fillRule="evenodd"
                            stroke="#141414"
                            strokeLinecap="square"
                          >
                            <path d="M12 6.5H1" />
                            <path d="M6.5 1v11" />
                          </g>
                        </svg>
                      </Icon>
                    </Toggler>
                  }
                  {!searchResultsLoading && results.length && search && page ?
                    <StaggeredMotion
                      defaultStyles={this.getSearchStyles('pages')}
                      styles={prevInterpolatedStyles => prevInterpolatedStyles.map((_, i) => {
                        return i === 0
                          ? { o: spring(1), t: spring(0) }
                          : { o: spring(prevInterpolatedStyles[i - 1].o), t: spring(prevInterpolatedStyles[i - 1].t) }
                      })}
                    >
                      {interpolatingStyles =>
                        <Alternating>
                          {interpolatingStyles.map((style, i) =>
                            <Result
                              href={getRelativeUrl(pages[i].link)}
                              key={i}
                              style={{ opacity: style.o, transform: `translateY(${style.t}px)` }}
                              align={'center'}
                              docType={'pages'}
                            >
                              <Title dangerouslySetInnerHTML={{ __html: pages[i].title }}></Title>
                              <Desc>
                                {this.indexFinder(pages[i]) !== -1 ? this.toPlainText(pages[i].modules[this.indexFinder(pages[i])].body.slice(0, 200) + "...") : ""}
                              </Desc>
                              <More><LocalizedString group="genericLabels" string="readMore" /></More>
                            </Result>
                          )}
                        </Alternating>
                      }
                    </StaggeredMotion>
                    : searchResultsLoading ? <h1></h1> : <h1></h1>}
                </Col>
              </Row>}
            <Row>
              <Col xlOffset={2} xl={6}>
                <ButtonContainer>
                  <CSSTransition
                    key={1}
                    in={anim}
                    timeout={1000}
                    classNames="list-transition"
                    unmountOnExit
                    appear
                  >
                    <MenuButton href={"https://www.dol-sensors.com/products/"}><span><LocalizedString group='results' string='products_button' /></span></MenuButton>
                  </CSSTransition>
                  <CSSTransition
                    key={2}
                    in={anim}
                    timeout={1000}
                    classNames="list-transition"
                    unmountOnExit
                    appear
                  >
                    <MenuButton href={"https://www.dol-sensors.com/documentation/"}><span><LocalizedString group='results' string='technical_button' /></span></MenuButton>
                  </CSSTransition>
                  <CSSTransition
                    key={3}
                    in={anim}
                    timeout={1000}
                    classNames="list-transition"
                    unmountOnExit
                    appear
                  >
                    <MenuButton href={"https://www.dol-sensors.com/locate-a-dealer/"}><span><LocalizedString group='results' string='locate_a_dealer_button' /></span></MenuButton>
                  </CSSTransition>
                </ButtonContainer>
              </Col>
            </Row>
            {anim &&
              <Row>
                <Col xlOffset={2} xl={2}>
                  <Address>
                    <AddressTitle><LocalizedString group='results' string='head_office' /></AddressTitle>
                    <a href={'tel:+45-7217-5888'}>T: +45 7217 5888</a>
                    <a href={'mailto:mail@dol-sensors.com'}>E: mail@dol-sensors.com</a>
                  </Address>
                </Col>
              </Row>
            }
          </Container>
        }


        <FooterFixed res={visible && results.length !== 0}>
          {/* <Footer /> */}
        </FooterFixed>
      </Wrapper>
    )
  }
}

export default compose(

  withLangDoc(
    props => ({
      search: props.search
    })
  ),
  withLangSearch(
    props => ({
      search: props.search
    })
  ),
  withRouter,
  withTranslations()
)(Results)



// WEBPACK FOOTER //
// ./src/ui/components/Navigation/Search/Results.js